import { HoveredItem, LayerFilter } from './types'

export function getFilteredFeatures(
  features: HoveredItem[],
  layerFilter?: LayerFilter,
): HoveredItem[] {
  if (!layerFilter) {
    return features
  }

  if (typeof layerFilter === 'function') {
    return features.filter((f) =>
      (layerFilter as (layerName: string) => boolean)(f.layerName),
    )
  }

  if (Array.isArray(layerFilter)) {
    return features.filter((f) =>
      (layerFilter as string[]).includes(f.layerName),
    )
  }

  if (typeof layerFilter === 'string') {
    return features.filter((f) => f.layerName === (layerFilter as string))
  }

  return features
}
